<template>
  <div>
    <b-row>
      <!-- ==============================  FILTERS_SECTION START ============================== -->
      <b-col class="col-md-2">
        <AppSearchInput
          v-if="card == 'Материалы'"
          v-model="paramsMaterial.search"
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="refresh()"
        />
        <AppSearchInput
          v-if="card == 'Инструменты'"
          v-model="paramsInstruments.search2"
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="refresh()"
        />
      </b-col>

      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('filter_by_destination_warehouse') + ':'">
          <v-select
            v-if="card == 'Материалы'"
            v-model="paramsMaterial.to_storage"
            class="bg-white rounded"
            label="title"
            :options="GET_APPLICATION_TYPE"
            :reduce="(p) => p.id"
            @input="onFiltered"
          />
          <v-select
            v-if="card == 'Инструменты'"
            v-model="paramsInstruments.to_storage2"
            class="bg-white rounded"
            label="title"
            :options="GET_APPLICATION_TYPE"
            :reduce="(p) => p.id"
            @input="onFiltered"
          />
        </b-form-group>
      </b-col>

      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('dateFromTo') + ':'" v-if="card == 'Материалы'">
          <VueDataPicker
            v-model="dateFilter"
            placeholder=""
            :other-props="{ 'is-range': true }"
            @input="datePicker"
          />
        </b-form-group>
        <b-form-group :label="$t('dateFromTo') + ':'" v-if="card == 'Инструменты'">
          <VueDataPicker
            v-model="dateFilter2"
            placeholder=""
            :other-props="{ 'is-range': true }"
            @input="datePicker"
          />
        </b-form-group>
      </b-col>

      <!-- ==============================  FILTERS_SECTION END ============================== -->

      <b-col
        class="col-6 d-flex align-items-center justify-content-end"
        style="margin-top: 10px"
      >
        <b-form-radio-group
          id="radio-group-1"
          v-model="card"
          class="list item-view-radio-group"
          :options="itemViewOptions"
          buttons
          @input="onFiltered()"
          button-variant="outline-primary"
        >
        </b-form-radio-group>
      </b-col>

      <b-col v-if="!isLoading">
        <!-- <b-card> -->
        <b-table
          v-if="card == 'Материалы'"
          id="user-table"
          class="px-1 rounded mt-1 bg-light-secondary"
          :fields="fields"
          :items="applicationMaterialMovement.results"
          show-empty
          :tbody-tr-class="['tableRowClass']"
          small
          responsive
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(goods)="{ item }">
            <b-badge
              v-for="(good, index) in item.objects"
              :key="index"
              variant="success"
              class="ml-50"
            >
              {{ good && good.good && good.good.product && good.good.product.title ? good.good.product.title : '' }}
            </b-badge>
          </template>

          <template #cell(requirement_type)="{ value }">
            <b-badge v-if="value" variant="success">{{ value }}</b-badge>
          </template>

          <template #cell(status)="props">
            <div class="d-flex justify-content-center">
              <b-badge
                v-if="props.item.status"
                :variant="props.item.status.color"
              >
                <span>{{ props.item.status.name }}</span>
              </b-badge>
              <feather-icon
                v-b-tooltip.focus="{ variant: props.item.status.color }"
                :title="props.item.status.description"
                class="ml-25"
                icon="InfoIcon"
                size="24"
              />
            </div>
          </template>

          <template #cell(good)="{ item }">
            <div v-for="(good, index) in item.objects" :key="index">
              <!-- <span>{{ good.good.product.character }} - </span> -->
              <span>{{ good.good.value }}</span>
            </div>
          </template>

          <template #cell(actions)="props">
            <div class="d-flex align-items-center justify-content-center">
              <b-button
                v-b-tooltip.hover.v-primary
                :title="$t('watch')"
                size="sm"
                class="mt-50 mb-50"
                variant="primary"
                @click="$router.push(`/moving/view/material/${props.item.id}`)"
              >
                <feather-icon icon="EyeIcon" size="15" />
              </b-button>

              <template v-if="props.item.status">
                <template v-for="(item, index) in props.item.status.change_to">
                  <b-button
                    v-if="
                      checkButtonPermission([...item.roles, 'admin']) &&
                      hideButtonIfNeeded(props.item)
                    "
                    :key="index"
                    v-b-tooltip.hover="{ variant: item.color }"
                    :title="item.name"
                    size="sm"
                    class="ml-50 mt-50 mb-50"
                    :variant="item.color"
                    @click="onChangeStatus(props, item)"
                  >
                    <feather-icon :icon="item.icon" size="15" />
                  </b-button>
                </template>
              </template>
            </div>
          </template>
        </b-table>
        <b-table
          v-if="card == 'Инструменты'"
          id="user-table"
          class="px-1 rounded mt-1 bg-light-secondary"
          :fields="fieldsInstrument"
          :items="applicationInstrumentMovement.results"
          show-empty
          :tbody-tr-class="['tableRowClass']"
          small
          responsive
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(instruments)="{ item }">
            <b-badge
              v-for="(elem, index) in item.objects"
              :key="index"
              variant="success"
              class="ml-50"
            >
              {{ elem.instrument.type.title }}
            </b-badge>
          </template>

          <template #cell(instrument)="{ item }">
            <span v-for="(elem, index) in item.objects" :key="index">
              {{ elem.instrument.title }}
            </span>
          </template>

          <template #cell(status)="props">
            <div class="d-flex justify-content-center">
              <b-badge
                v-if="props.item.status && props.item.status.color"
                :variant="props.item.status.color"
              >
                <span>{{ props.item.status.name }}</span>
              </b-badge>
              <feather-icon
                v-if="props.item.status && props.item.status.description"
                v-b-tooltip.focus="{ variant: props.item.status.color }"
                :title="props.item.status.description"
                class="ml-25"
                icon="InfoIcon"
                size="24"
              />
            </div>
          </template>

          <template #cell(actions)="props">
            <div class="d-flex align-items-center justify-content-center">
              <b-button
                v-b-tooltip.hover.v-primary
                :title="$t('watch')"
                size="sm"
                variant="primary"
                class="mt-50 mb-50"
                @click="$router.push(`/moving/view/instrument/${props.item.id}`)"
              >
                <feather-icon icon="EyeIcon" size="15" />
              </b-button>

              <template v-if="props.item.status">
                <template v-for="(item, index) in props.item.status.change_to">
                  <b-button
                    v-if="
                      checkButtonPermission([...item.roles, 'admin']) &&
                      hideButtonIfNeeded(props.item)
                    "
                    :key="index"
                    v-b-tooltip.hover="{ variant: item.color }"
                    :title="item.name"
                    size="sm"
                    class="ml-50"
                    :variant="item.color"
                    @click="onChangeStatus(props, item)"
                  >
                    <feather-icon :icon="item.icon" size="15" />
                  </b-button>
                </template>
              </template>
            </div>
          </template>
        </b-table>
        <!-- </b-card> -->
      </b-col>
      <b-col v-else>
        <b-card>
          <Loader />
        </b-card>
      </b-col>




      <!-- ==============================  PAGINATION_SECTION START ============================== -->
      <Pagination
        class="w-100"
        v-if="card == 'Материалы'"
        :params="paramsMaterial"
        :rows="applicationMaterialMovement.count"
        @refresh="refresh()"
      />
      <Pagination
        class="w-100"
        v-if="card == 'Инструменты'"
        :params="paramsInstruments"
        :rows="applicationInstrumentMovement.count"
        @refresh="refresh()"
      />
      <!-- ==============================  PAGINATION_SECTION END ============================== -->




    </b-row>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BButton,
  BTable,
  BFormRadio,
  BFormRadioGroup,
  BCard,
  BFormGroup,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapState } from "vuex";
import vSelect from "vue-select";
import AppSearchInput from "@/components/AppSearchInput.vue";
import VueDataPicker from "@/components/VueDatePicker.vue";
import Pagination from "@/components/Pagination.vue";
import areYouSure from "@/mixins/areYouSure";
import addQueryToCurrentPage from "@/mixins/addQueryToCurrentPage";
import check from "@/mixins/check";
import { getUserData } from "@/auth/utils";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    BCol,
    BRow,
    BButton,
    BFormGroup,
    vSelect,
    AppSearchInput,
    VueDataPicker,
    BTable,
    BBadge,
    Loader,
    BCard,
    Pagination,
    BFormRadio,
    BFormRadioGroup,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [areYouSure, check, loader, addQueryToCurrentPage],
  data() {
    return {
      isLoading: false,
      // ==================== PRIMARY_SECTION START ====================
      card: "Материалы",
      paramsMaterial: {
        search: "",
        to_storage: "",
        requirement_type: '',

        page_size: 10,
        page: 1,
      },
      paramsInstruments: {
        search2: "",
        to_storage2: "",
        requirement_type: '',

        page_size2: 10,
        page2: 1,
      },
      itemViewOptions: [
        {
          text: this.$t("reference.material"),
          value: "Материалы",
        },
        {
          text: this.$t("reference.instrument"),
          value: "Инструменты",
        },
      ],
      dateFilter: {
        start_date: '',
        end_date: '',
      },
      dateFilter2: {
        start_date2: '',
        end_date2: '',
      },
      // ==================== PRIMARY_SECTION END ====================








      // ==================== OTHERS_SECTION START ====================
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "where2",
          key: "from_storage",
          formatter: (data) => data?.title,
          thClass: "tableHeadClass",
        },
        {
          label: "where",
          key: "to_storage",
          formatter: (data) => data?.title,
          thClass: "tableHeadClass",
        },
        // {
        //   label: "courses.type",
        //   key: "goods",
        //   thClass: "tableHeadClass",
        // },
        {
          label: "namee",
          key: "good",
          thClass: "tableHeadClass",
        },
        {
          label: "general.created_at",
          key: "created_at",
          formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
          thClass: "tableHeadClass",
        },
        {
          label: "status",
          key: "status",
          formatter: (data) => data?.name,
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],

      fieldsInstrument: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "where2",
          key: "from_storage",
          formatter: (data) => data?.title,
          thClass: "tableHeadClass",
        },
        {
          label: "where",
          key: "to_storage",
          formatter: (data) => data?.title,
          thClass: "tableHeadClass",
        },
        {
          label: "courses.type",
          key: "instrument",
          thClass: "tableHeadClass",
        },
        {
          label: "namee",
          key: "instruments",
          thClass: "tableHeadClass",
        },
        {
          label: "general.created_at",
          key: "created_at",
          formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
          thClass: "tableHeadClass",
        },
        {
          label: "status",
          key: "status",
          formatter: (data) => data?.name,
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
      // ==================== OTHERS_SECTION END ====================







    };
  },
  computed: {
    ...mapState("application", [
      "applicationMaterialMovement",
      "applicationInstrumentMovement",
    ]),
    ...mapGetters("application", [
      "GET_APPLICATION_TYPE",
    ]),
  },
  watch: {

  },
  async mounted() {
    // await this.$_loaderStart();
    this.isLoading = true;




    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_APPLICATION_MATERIAL_MOVEMENT({
      page: this.$route.query.page ? this.$route.query.page : 1,
      page_size: this.$route.query.page_size ? this.$route.query.page_size : 10,

      search: this.$route.query.search ? this.$route.query.search : '',
      to_storage: this.$route.query.to_storage ? this.$route.query.to_storage : '',

      start_date: this.$route.query.start_date ? this.$route.query.start_date : '',
      end_date: this.$route.query.end_date ? this.$route.query.end_date : '',
    });
    await this.FETCH_APPLICATION_INSTRUMENT_MOVEMENT({
      page: this.$route.query.page2 ? this.$route.query.page2 : 1,
      page_size: this.$route.query.page_size2 ? this.$route.query.page_size2 : 10,

      search: this.$route.query.search2 ? this.$route.query.search2 : '',
      to_storage: this.$route.query.to_storage2 ? this.$route.query.to_storage2 : '',

      start_date: this.$route.query.start_date2 ? this.$route.query.start_date2 : '',
      end_date: this.$route.query.end_date2 ? this.$route.query.end_date2 : '',
    });



    let to_storage = this.GET_APPLICATION_TYPE.find((elem) => elem.id == this.$route.query.to_storage)
    if(to_storage){
      this.paramsMaterial.to_storage = {id: to_storage.id, title: to_storage.title}
    }


    let to_storage2 = this.GET_APPLICATION_TYPE.find((elem) => elem.id == this.$route.query.to_storage2)
    if(to_storage2){
      this.paramsInstruments.to_storage2 = {id: to_storage2.id, title: to_storage2.title}
    }


    this.card = this.$route.query.card ? this.$route.query.card : 'Материалы';
    
    this.paramsMaterial.search = this.$route.query.search ? this.$route.query.search : '';
    this.paramsInstruments.search2 = this.$route.query.search2 ? this.$route.query.search2 : '';

    this.dateFilter.start_date = this.$route.query.start_date ? this.$route.query.start_date : '';
    this.dateFilter.end_date = this.$route.query.end_date ? this.$route.query.end_date : '';

    this.dateFilter2.start_date2 = this.$route.query.start_date2 ? this.$route.query.start_date2 : '';
    this.dateFilter2.end_date2 = this.$route.query.end_date2 ? this.$route.query.end_date2 : '';

    this.paramsMaterial.page_size = this.$route.query.page_size ? this.$route.query.page_size : 10;
    this.paramsInstruments.page_size2 = this.$route.query.page_size2 ? this.$route.query.page_size2 : 10;


    setTimeout(() => {
      this.paramsMaterial.page = this.$route.query.page ? this.$route.query.page : 1;
      this.paramsInstruments.page2 = this.$route.query.page2 ? this.$route.query.page2 : 1;
    }, 0)
    // ===============  PRIMARY_REQUESTS_SECTION END ===============






    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_APPLICATION_AUTHOR({ role_unique_name: "builder" });
    await this.FETCH_APPLICATION_STATUS({ content_type_model: "requirements" });
    await this.FETCH_APPLICATION_TYPE({ is_object: 1, mini: true });
    // ===============  PRIMARY_REQUESTS_SECTION END ===============
    this.isLoading = false;
  },

  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },

  methods: {
    ...mapActions("application", [
      "FETCH_APPLICATION_MATERIAL_MOVEMENT",
      "FETCH_APPLICATION_INSTRUMENT_MOVEMENT",
      "UPDATE_APPLICATION_MATERIAL_MOVEMENT",
      "UPDATE_APPLICATION_INSTRUMENT_MOVEMENT",
    ]),

    ...mapActions("application", [
      "FETCH_APPLICATION_STATUS",
      "FETCH_APPLICATION_AUTHOR",
      "FETCH_APPLICATION_TYPE",
    ]),











    // =============== REFRESH_SECTION START ===============
    async refresh() {
      this.isLoading = true;

      let filter = {}
      if(this.paramsInstruments.page){
        this.paramsInstruments.page2 = this.paramsInstruments.page
      }
      filter = {...this.paramsMaterial, ...this.paramsInstruments}


      if (this.card == "Материалы") {

        if(this.paramsMaterial.to_storage){
          filter.to_storage = typeof this.paramsMaterial.to_storage == "number" ? this.paramsMaterial.to_storage : this.paramsMaterial.to_storage.id
        }

        await this.FETCH_APPLICATION_MATERIAL_MOVEMENT({
          ...this.paramsMaterial,
          start_date: this.dateFilter.start_date,
          end_date: this.dateFilter.end_date,
        });


      } else {

        if(this.paramsInstruments.to_storage2){
          filter.to_storage = typeof this.paramsInstruments.to_storage2 == "number" ? this.paramsInstruments.to_storage2 : this.paramsInstruments.to_storage2.id
        }

        await this.FETCH_APPLICATION_INSTRUMENT_MOVEMENT({
          search: this.paramsInstruments.search2,
          to_storage: this.paramsInstruments.to_storage2,
          requirement_type: this.paramsInstruments.requirement_type,
          page_size: this.paramsInstruments.page_size2,
          page: this.paramsInstruments.page2,

          start_date: this.dateFilter2.start_date2,
          end_date: this.dateFilter2.end_date2,
        });

      }

      
      let dates = {
        start_date: this.dateFilter && this.dateFilter.start_date ? this.dateFilter.start_date : '',
        end_date: this.dateFilter && this.dateFilter.end_date ? this.dateFilter.end_date : '',
        start_date2: this.dateFilter2 && this.dateFilter2.start_date2 ? this.dateFilter2.start_date2 : '',
        end_date2: this.dateFilter2 && this.dateFilter2.end_date2 ? this.dateFilter2.end_date2 : '',
      }
      this.$_addParamsToLocation({ ...filter, ...dates, card: this.card })
      this.isLoading = false;
    },
    // =============== REFRESH_SECTION END ===============











    // ===============  SEARCH_SECTION START ===============
    async onFiltered() {
      this.isLoading = true;
      let filter = {}
      if(this.paramsInstruments.page){
        this.paramsInstruments.page2 = this.paramsInstruments.page
      }
      filter = {...this.paramsMaterial, ...this.paramsInstruments}

      if (this.card == "Материалы") {
        // this.paramsMaterial.page = 1;

        await this.FETCH_APPLICATION_MATERIAL_MOVEMENT({
          ...this.paramsMaterial,
          start_date: this.dateFilter.start_date,
          end_date: this.dateFilter.end_date,
        });
      } else {
        // this.paramsInstruments.page2 = 1;

        await this.FETCH_APPLICATION_INSTRUMENT_MOVEMENT({
          search: this.paramsInstruments.search2,
          to_storage: this.paramsInstruments.to_storage2,
          requirement_type: this.paramsInstruments.requirement_type,
          page_size: this.paramsInstruments.page_size2,
          page: this.paramsInstruments.page2,

          start_date: this.dateFilter2.start_date2,
          end_date: this.dateFilter2.end_date2,
        });
      }

      
      let dates = {
        start_date: this.dateFilter && this.dateFilter.start_date ? this.dateFilter.start_date : '',
        end_date: this.dateFilter && this.dateFilter.end_date ? this.dateFilter.end_date : '',
        start_date2: this.dateFilter2 && this.dateFilter2.start_date2 ? this.dateFilter2.start_date2 : '',
        end_date2: this.dateFilter2 && this.dateFilter2.end_date2 ? this.dateFilter2.end_date2 : '',
      }
      this.$_addParamsToLocation({ ...filter, ...dates, card: this.card })
      this.isLoading = false;
    },


    async search() {
      this.isLoading = true;
      this.paramsMaterial.page = 1;
      this.paramsInstruments.page2 = 1;
      let filter = {}
      filter = {...this.paramsMaterial, ...this.paramsInstruments}


      if (this.card == "Материалы") {
        await this.FETCH_APPLICATION_MATERIAL_MOVEMENT({
          ...this.paramsMaterial,
          start_date: this.dateFilter.start_date,
          end_date: this.dateFilter.end_date,
        });
      } else {

        await this.FETCH_APPLICATION_INSTRUMENT_MOVEMENT({
          search: this.paramsInstruments.search2,
          to_storage: this.paramsInstruments.to_storage2,
          requirement_type: this.paramsInstruments.requirement_type,
          page_size: this.paramsInstruments.page_size2,
          page: this.paramsInstruments.page2,

          start_date: this.dateFilter2.start_date2,
          end_date: this.dateFilter2.end_date2,
        });
      }

      let dates = {
        start_date: this.dateFilter && this.dateFilter.start_date ? this.dateFilter.start_date : '',
        end_date: this.dateFilter && this.dateFilter.end_date ? this.dateFilter.end_date : '',
        start_date2: this.dateFilter2 && this.dateFilter2.start_date2 ? this.dateFilter2.start_date2 : '',
        end_date2: this.dateFilter2 && this.dateFilter2.end_date2 ? this.dateFilter2.end_date2 : '',
      }
      this.$_addParamsToLocation({ ...filter, ...dates, card: this.card })
      this.isLoading = false;
    },
    // ===============  SEARCH_SECTION END ===============














    // ===============  DATE_PICKER_SECTION START ===============
    async datePicker(e) {
      this.isLoading = true;
      let filter = {}

      // this.paramsMaterial.page = 1;
      // this.paramsInstruments.page2 = 1;
      if(this.paramsInstruments.page){
        this.paramsInstruments.page2 = this.paramsInstruments.page
      }
      filter = {...this.paramsMaterial, ...this.paramsInstruments}

      if (e) {
        if (this.card == "Материалы" && e.start && e.end) {
          this.dateFilter.start_date = e.start;
          this.dateFilter.end_date = e.end;


          await this.FETCH_APPLICATION_MATERIAL_MOVEMENT({
            ...this.paramsMaterial,
            start_date: this.dateFilter.start_date,
            end_date: this.dateFilter.end_date,
          });
        } else if (this.card == "Инструменты" && e.start && e.end) {
          this.dateFilter2.start_date2 = e.start;
          this.dateFilter2.end_date2 = e.end;


          await this.FETCH_APPLICATION_INSTRUMENT_MOVEMENT({
            search: this.paramsInstruments.search2,
            to_storage: this.paramsInstruments.to_storage2,
            requirement_type: this.paramsInstruments.requirement_type,
            page_size: this.paramsInstruments.page_size2,
            page: this.paramsInstruments.page2,
            
            start_date: this.dateFilter2.start_date2,
            end_date: this.dateFilter2.end_date2,
          });
        }
      } else {
        if (this.card == "Материалы") {
          await this.FETCH_APPLICATION_MATERIAL_MOVEMENT(this.paramsMaterial);
        } else {

          await this.FETCH_APPLICATION_INSTRUMENT_MOVEMENT({
            search: this.paramsInstruments.search2,
            to_storage: this.paramsInstruments.to_storage2,
            requirement_type: this.paramsInstruments.requirement_type,
            page_size: this.paramsInstruments.page_size2,
            page: this.paramsInstruments.page2,
          });
        }
      }

      let dates = {
        start_date: this.dateFilter && this.dateFilter.start_date ? this.dateFilter.start_date : '',
        end_date: this.dateFilter && this.dateFilter.end_date ? this.dateFilter.end_date : '',
        start_date2: this.dateFilter2 && this.dateFilter2.start_date2 ? this.dateFilter2.start_date2 : '',
        end_date2: this.dateFilter2 && this.dateFilter2.end_date2 ? this.dateFilter2.end_date2 : '',
      }
      this.$_addParamsToLocation({ ...filter, ...dates, card: this.card })
      this.isLoading = false;
    },
    // ===============  DATE_PICKER_SECTION END ===============














    hideButtonIfNeeded(item) {
      let userData = getUserData();

      if (item?.from_storage?.id == userData?.storage_object) {
        return true;
      } else {
        return false;
      }
    },




    // =============== ON_CHANGE_STATUS_SECTION START ===============
    onChangeStatus(props, item) {
      const status = {
        accept_movement: this.$t("accepted"),
        on_way_movement: this.$t("send_on_the_way"),
      };
      this.$bvModal
        .msgBoxConfirm(
          this.$t("do_you_really_want") + ` ${status[item.unique_name]} ?`,
          {
            title: this.$i18n.t("attention"),
            size: "sm",
            okVariant: item.color,
            okTitle: this.$t("yes"),
            cancelTitle: this.$t("no"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (value) {
            if (this.card) {
              this.UPDATE_APPLICATION_MATERIAL_MOVEMENT({
                status_unique: item.unique_name,
                id: props.item.id,
              }).then(() => {
                this.refresh();
              });
            } else {
              this.UPDATE_APPLICATION_INSTRUMENT_MOVEMENT({
                status_unique: item.unique_name,
                id: props.item.id,
              }).then(() => {
                this.refresh();
              });
            }
          }
        });
    },
    // =============== ON_CHANGE_STATUS_SECTION END ===============












  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.item-view-radio-group{
  color: black !important;
}

.dark-layout #radio-group-1 span{
  color: white !important;
}

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

//  кнопка переключения между заявками и инструментами
[dir] .btn-outline-primary:not(:disabled):not(.disabled).active {
  background-color: #5a9cd9;
  color: white;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
